var partnerCardBlock = (function () {
  var paramsValue = {},
    queryStringUTM = "";

  //init function
  function init() {
    fnFindAPartnerModal();

    //var declaration
    var partnerRegion = document.getElementById("partnerRegion"),
      partnerProducts = document.getElementById("partnerProducts"),
      partnerType = document.getElementById("partnerType"),
      partnerSearch = document.getElementById("partnerSearch"),
      clearPartnerFilter = document.getElementById("clearPartnerFilter"),
      showMoreBtn = document.querySelector(".btn-partners-show-more");

    var whiteListParams = [
        "utm_source",
        "utm_medium",
        "utm_platform",
        "utm_content",
        "utm_campaign",
        "utm_campaigncode",
        "utm_term",
      ],
      paramsObj = window.location.search
        .slice(1)
        .split("&")
        .map(function (p) {
          return p.split("=");
        })
        .reduce(function (obj, pair) {
          if (pair.length >= 2) {
            obj[pair[0]] = pair[1];
          }
          return obj;
        }, {});

    //Read from cookie
    if (Object.keys(paramsObj).length == 0) {
      var cookieUtmParams = Cookie.read(
        stage_env_cookie_prefix + "user_utm_data"
      );
      if (cookieUtmParams) {
        paramsObj = bsLib.JSONParse(cookieUtmParams);
      }
    }

    // check white list params
    Object.keys(paramsObj).forEach(function (key) {
      if (whiteListParams.indexOf(key) > -1) {
        paramsValue[key] = paramsObj[key];
      }
    });

    // Partner Region DropDown
    if (partnerRegion) {
      new ChosenCustom({
        selector: partnerRegion,
        ID: "selectRegion",
        placeholder: "Region",
        search: true,
        searchPlaceholder: "Search Region...",
      });

      partnerRegion.addEventListener("change", function (evt) {
        var that = this,
          dataAjax = {
            perpage: showMoreBtn.dataset.perpage,
            offset: 0,
            region: that.value,
            product: partnerProducts.value,
            type: partnerType.value,
            q: partnerSearch.value,
          };

        partnerCardDataAjax(dataAjax);

        clearPartnerFilter.classList.remove("hide");

        //active
        that.closest(".partners-card-block__filter-dd").classList.add("active");

        paramsValue["partner-region"] = that.value;
        paramsValue["partner-product"] = partnerProducts.value;
        paramsValue["partner-type"] = partnerType.value;
        paramsValue["partner-search"] = partnerSearch.value;
        paramsValue["partners-page"] = 0;

        updateQueryStringParameter();
      });
    }

    // Partners Products DropDown
    if (partnerProducts) {
      new ChosenCustom({
        selector: partnerProducts,
        ID: "selectProducts",
        placeholder: "Product",
        search: true,
        searchPlaceholder: "Search Product...",
      });

      partnerProducts.addEventListener("change", function (evt) {
        var that = this,
          dataAjax = {
            perpage: showMoreBtn.dataset.perpage,
            offset: 0,
            region: partnerRegion.value,
            product: that.value,
            type: partnerType.value,
            q: partnerSearch.value,
          };

        partnerCardDataAjax(dataAjax);

        clearPartnerFilter.classList.remove("hide");

        //active
        that.closest(".partners-card-block__filter-dd").classList.add("active");

        paramsValue["partner-region"] = partnerRegion.value;
        paramsValue["partner-product"] = that.value;
        paramsValue["partner-type"] = partnerType.value;
        paramsValue["partner-search"] = partnerSearch.value;
        paramsValue["partners-page"] = 0;

        updateQueryStringParameter();
      });
    }

    // Partner Type DropDown
    if (partnerType) {
      new ChosenCustom({
        selector: partnerType,
        ID: "selectPartnerType",
        placeholder: "Partner Type",
        search: true,
        searchPlaceholder: "Search Partner Type...",
      });

      partnerType.addEventListener("change", function (evt) {
        var that = this,
          dataAjax = {
            perpage: showMoreBtn.dataset.perpage,
            offset: 0,
            region: partnerRegion.value,
            product: partnerProducts.value,
            type: that.value,
            q: partnerSearch.value,
          };

        partnerCardDataAjax(dataAjax);

        clearPartnerFilter.classList.remove("hide");

        //active
        that.closest(".partners-card-block__filter-dd").classList.add("active");

        paramsValue["partner-region"] = partnerRegion.value;
        paramsValue["partner-product"] = partnerProducts.value;
        paramsValue["partner-type"] = that.value;
        paramsValue["partner-search"] = partnerSearch.value;
        paramsValue["partners-page"] = 0;

        updateQueryStringParameter();
      });
    }

    // Partner Search
    if (partnerSearch) {
      partnerSearch.addEventListener(
        "keyup",
        function (evt) {
          var that = this,
            inputVal = that.value.trim();
          if (inputVal !== "" && inputVal.length) {
            partnerSearch.classList.add("active");
          } else {
            partnerSearch.classList.remove("active");
          }
        },
        false
      );

      // Execute a function when the user presses a key on the keyboard
      partnerSearch.addEventListener(
        "keypress",
        function (evt) {
          // If the user presses the "Enter" key on the keyboard
          if (evt.key === "Enter") {
            evt.preventDefault();

            var that = this,
              dataAjax = {
                perpage: showMoreBtn.dataset.perpage,
                offset: 0,
                region: partnerRegion.value,
                product: partnerProducts.value,
                type: partnerType.value,
                q: that.value.trim(),
              };

            if (
              that.value.trim() === "" &&
              window.location.href.indexOf("partner-search") > 0
            ) {
              partnerCardDataAjax(dataAjax);
            } else if (that.value.trim() !== "") {
              partnerCardDataAjax(dataAjax);
            }

            if (
              that.value.trim() === "" &&
              partnerRegion.value === "" &&
              partnerProducts.value === "" &&
              partnerType.value === ""
            ) {
              clearPartnerFilter.classList.add("hide");
            } else {
              clearPartnerFilter.classList.remove("hide");
            }

            paramsValue["partner-region"] = partnerRegion.value;
            paramsValue["partner-product"] = partnerProducts.value;
            paramsValue["partner-type"] = partnerType.value;
            paramsValue["partner-search"] = that.value.trim();
            paramsValue["partners-page"] = 0;

            updateQueryStringParameter();
          }
        },
        false
      );
    }

    // Partner Clear Button
    if (clearPartnerFilter) {
      clearPartnerFilter.addEventListener(
        "click",
        function (evt) {
          evt.preventDefault();

          var that = this,
            dataAjax = {
              perpage: showMoreBtn.dataset.perpage,
              offset: 0,
              region: "",
              product: "",
              type: "",
              q: "",
            };

          partnerCardDataAjax(dataAjax);

          //remove active class
          partnerRegion
            .closest(".partners-card-block__filter-dd")
            .classList.remove("active");
          partnerProducts
            .closest(".partners-card-block__filter-dd")
            .classList.remove("active");
          partnerType
            .closest(".partners-card-block__filter-dd")
            .classList.remove("active");
          partnerSearch.classList.remove("active");

          //chosen reset
          new ChosenCustom({
            selector: partnerRegion,
            reset: true,
          });

          new ChosenCustom({
            selector: partnerProducts,
            reset: true,
          });

          new ChosenCustom({
            selector: partnerType,
            reset: true,
          });

          //search reset
          partnerSearch.value = "";

          that.classList.add("hide");

          delete paramsValue["partner-region"];
          delete paramsValue["partner-product"];
          delete paramsValue["partner-type"];
          delete paramsValue["partner-search"];
          delete paramsValue["partners-page"];

          updateQueryStringParameter();
        },
        false
      );
    }

    //Partner Pagination show more button
    if (showMoreBtn) {
      showMoreBtn.addEventListener(
        "click",
        function (evt) {
          evt.preventDefault();

          var that = this,
            dataAjax = {
              perpage: that.dataset.perpage,
              offset: that.dataset.offset,
              region: partnerRegion.value,
              product: partnerProducts.value,
              type: partnerType.value,
              q: partnerSearch.value.trim(),
            };

          partnerCardDataAjax(dataAjax);

          paramsValue["partner-region"] = partnerRegion.value;
          paramsValue["partner-product"] = partnerProducts.value;
          paramsValue["partner-type"] = partnerType.value;
          paramsValue["partner-search"] = partnerSearch.value.trim();
          paramsValue["partners-page"] = 0;

          updateQueryStringParameter();
        },
        false
      );
    }
  }

  function partnerCardDataAjax(dataAjax) {
    var pageBtn = document.querySelector(".btn-partners-show-more"),
      noResultsPartners = document.getElementById("noResultsPartners"),
      loaderContent = document.querySelector(
        ".partners-card-block-loading-container"
      );

    pageBtn.classList.add("visible-hide");
    noResultsPartners.classList.add("hide");

    if (loaderContent) {
      loaderContent.classList.remove("hide");
    }

    bsLib.ajax(
      "POST",
      bsLib.railsHost() + "/wp-admin/admin-ajax.php",
      bsLib.extend(
        {
          action: "bstack_partner_card_data",
          security: ajax_initialize_script.ajax_nonce,
        },
        dataAjax
      ),
      true, //async
      {
        "content-type": "application/x-www-form-urlencoded; charset=UTF-8",
      }, //request header
      function (data) {
        if (data.readyState === 4) {
          var dataRequest = bsLib.JSONParse(data.response),
            partnersCardRow = document.querySelector(
              ".partners-card-block .partners-card-block__row"
            );

          if (dataRequest.status) {
            if (dataAjax.offset > 0) {
              var partnerCardElem = document.querySelectorAll(
                ".partners-card-block__child"
              );
              for (var i = 0; i < partnerCardElem.length; i++) {
                partnerCardElem[i].classList.add('partners-card-block__clone');
              }
              partnersCardRow.insertAdjacentHTML("beforeend", dataRequest.html);
            } else {
              partnersCardRow.innerHTML = dataRequest.html;
            }

            pageBtn.dataset.offset = dataRequest.offset;

            if (loaderContent) {
              loaderContent.classList.add("hide");
            }

            if (dataRequest.filtered == 0) {
              noResultsPartners.classList.remove("hide");
            }

            if (dataRequest.filtered < 3) {
              partnersCardRow.classList.add("partners-card-block__row--flex-start");
            } else {
              partnersCardRow.classList.remove(
                "partners-card-block__row--flex-start"
              );
            }

            if (dataRequest.offset * dataAjax.perpage < dataRequest.filtered) {
              pageBtn.classList.remove("visible-hide");
            }

            //attach click event on cards
            fnFindAPartnerModal();

            lazyLoading.show();
          }
        }
      }, //success
      function () {} //error object
    );
  }

  function fnFindAPartnerModal() {
    var partnerCardElem = document.querySelectorAll(
      ".partners-card-block__child:not(.partners-card-block__clone)"
    );

    if (partnerCardElem) {
      for (var i = 0; i < partnerCardElem.length; i++) {
        partnerCardElem[i].addEventListener("click", function (e) {
          e.preventDefault();
          var that = this,
            partnerCardWebsite = that.querySelector('.partners-card-block__website'),
            partnerCardAboutUs = that.querySelector('.partners-card-block__about'),
            partnerCardProducts = that.querySelector('.partners-card-block__products'),
            partnerCardDesc = that.querySelector('.partners-card-block__desc'),
            partnerCardRegion = that.querySelector('.partners-card-block__region'),
            partnerCardLogo = that.querySelector('.partners-card-block__logo'),
            partnerCardName = that.getAttribute("data-card-name"),
            partnerCardEmailId = that.getAttribute("data-card-email"),
            partnerContainer = document.getElementById("find-partner-modal-form"),
            partnerProductsUsed = document.getElementById('partnerProductsUsed'),
            partnerInfoDesc = document.getElementById('partnerInfoDesc'),
            partnerAboutUs = document.getElementById('partnerAboutUs'),
            partnerGetQuoteBtn = document.getElementById('partnerGetQuoteBtn'),
            partnerWebsiteLogo = document.getElementById('partnerWebsiteLogo');

          if (partnerCardName !== '') {
            document.getElementById('partnerName').innerHTML = partnerCardName.trim();
          }

          if (partnerCardWebsite && partnerCardWebsite.innerText.length) {
            document.getElementById('partnerWebsiteUrl').innerHTML = partnerCardWebsite.innerText.trim();
          }

          if (partnerCardRegion && partnerCardRegion.innerText.length) {
            document.getElementById('partnerModalRegion').innerHTML = partnerCardRegion.innerText.trim();
          }

          if (partnerCardLogo && partnerCardLogo.getAttribute('src') !== '') {
            var getLogoAltText = partnerCardLogo.getAttribute('alt') || partnerCardLogo.getAttribute('title');
            getLogoAltText = (getLogoAltText) ? getLogoAltText : 'Partner Logo';

            partnerWebsiteLogo.setAttribute('data-lazy-src', partnerCardLogo.getAttribute('src').trim());
            partnerWebsiteLogo.setAttribute('src', partnerCardLogo.getAttribute('src').trim());
            partnerWebsiteLogo.setAttribute('alt', getLogoAltText);
            partnerWebsiteLogo.setAttribute('title', getLogoAltText);
          }

          if (partnerCardAboutUs && partnerCardAboutUs.innerText.length) {
            partnerAboutUs.closest('.find-partner-form__wrapper').classList.remove('hide');
            partnerAboutUs.innerHTML = partnerCardAboutUs.innerText.trim();
          } else {
            partnerAboutUs.closest('.find-partner-form__wrapper').classList.add('hide');
          }

          if (partnerCardProducts && partnerCardProducts.innerText.length) {
            partnerProductsUsed.closest('.find-partner-form__wrapper').classList.remove('hide');
            partnerProductsUsed.innerHTML = partnerCardProducts.innerText.trim();
          } else {
            partnerProductsUsed.closest('.find-partner-form__wrapper').classList.add('hide');
          }

          if (partnerCardDesc && partnerCardDesc.innerText.length) {
            partnerInfoDesc.closest('.find-partner-form__wrapper').classList.remove('hide');
            partnerInfoDesc.innerHTML = partnerCardDesc.innerText.trim();
          } else {
            partnerInfoDesc.closest('.find-partner-form__wrapper').classList.add('hide');
          }

          // set partner email and partner name
          partnerGetQuoteBtn.setAttribute('data-partner-modal', partnerCardName.trim());
          partnerGetQuoteBtn.setAttribute('data-partner-email', partnerCardEmailId.trim());

          if (partnerContainer) {
            findPartnerModal = new tingle.modal({
              focusAfterClosed: this,
              setFocusOnCloseIcon: true,
              cssClass: ["find-partner-form-modal"],
              onClose: function () {
                findPartnerModal.destroy();
              },
            });
            findPartnerModal.setContent(partnerContainer.innerHTML);
            findPartnerModal.open();
            lazyLoading.show();
          }

          // attach click event on modal close
          var partnerCloseBtn = document.querySelectorAll(
            ".tingle-modal .find-partner-form__btn"
          );

          for (var i = 0; i < partnerCloseBtn.length; i++) {
            partnerCloseBtn[i].addEventListener("click", function (e) {
              e.preventDefault();
              var that = this,
                partnerNameText = that.getAttribute('data-partner-modal'),
                partnerNameEmailId = that.getAttribute('data-partner-email');
              
              if (findPartnerModal) { // close find partner modal
                findPartnerModal.destroy();
              }
              
              // get partner form elem
              var partnerMainForm = document.querySelector('#find-partner-modal-form .find-partner-form__btn');
              if (partnerMainForm) {
                partnerMainForm.click(); // trigger main partner form
                // event on form load
                WebEventTracker.logEvent(EDS.webEvents, "LoadPartnerForm", {
                  action: "Contact Partner",
                  partner: partnerNameText.trim(),
                });
                document.querySelector('.tingle-modal .partners-modal-form__heading').innerText = 'Have the Partner contact me';
                document.querySelector('.tingle-modal .partners-modal-form__desc').innerText = 'Please enter your contact information. A representative from ' + partnerNameText + ' will get in touch with you soon.';
                document.querySelector('.tingle-modal #form-role').setAttribute('placeholder', 'Engineering Manager');
                document.querySelector('.tingle-modal #partner-modal-name').value = partnerNameText.trim();
                document.querySelector('.tingle-modal #partner-modal-email-id').value = partnerNameEmailId.trim();
              }
            });
          }
        });
      }
    }
  }

  // Function to update Query String in the URL
  // https://jsfiddle.net/bp3tmuxh/1/
  function updateQueryStringParameter() {
    if (paramsValue.hasOwnProperty("partner-region")) {
      if (paramsValue["partner-region"] === "") {
        delete paramsValue["partner-region"];
      }
    }

    if (paramsValue.hasOwnProperty("partner-product")) {
      if (paramsValue["partner-product"] === "") {
        delete paramsValue["partner-product"];
      }
    }

    if (paramsValue.hasOwnProperty("partner-type")) {
      if (paramsValue["partner-type"] === "") {
        delete paramsValue["partner-type"];
      }
    }

    if (paramsValue.hasOwnProperty("partner-search")) {
      if (paramsValue["partner-search"] === "") {
        delete paramsValue["partner-search"];
      }
    }

    if (paramsValue.hasOwnProperty("partners-page")) {
      if (paramsValue["partners-page"] === 0) {
        delete paramsValue["partners-page"];
      }
    }

    if (Object.keys(paramsValue).length > 0) {
      queryStringUTM =
        "?" +
        Object.keys(paramsValue)
          .map(function (key) {
            return key + "=" + paramsValue[key];
          })
          .join("&");
    } else {
      queryStringUTM = "";
    }

    var uri = window.location.href.split("?")[0];

    if (history.pushState) {
      var hash = "";
      if (uri.indexOf("#") !== -1) {
        hash = uri.replace(/.*#/, "#");
        uri = uri.replace(/#.*/, "");
      }

      //update referrer
      var newReferrer = window.location.href;
      Object.defineProperty(document, "referrer", {
        configurable: true,
        get: function () {
          return newReferrer;
        },
      });

      window.history.pushState(
        { path: window.location.href },
        "",
        uri + queryStringUTM + hash
      );
    }
  }
  init();
})();